<template>
  <div class="content-box">
    <div class="support-index" :class="{ 'show-ticket-content': tarimaSeleccionada != null }">
      <div class="support-tickets">
        <div class="support-tickets-header">
          <div class="tickets-control">
            <div>
              <h5>Tarimas por Devolución</h5>
            </div>
          </div>
          <div class="tickets-control">
            <div class="row">
              <div class="col-3">
                <h6>Búsqueda:</h6>
              </div>
              <div class="col-7">
                <input class="form-control form-control-sm" placeholder="Search" v-model="searchtext" type="text"
                  v-on:keyup.enter="refreshTarimas" />
                <br />
              </div>
              <div class="input-group-append">
                <button v-on:click="refreshTarimas" class="btn btn-link btn-sm" type="submit">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-link btn-sm" type="button" @click="clearFilterData">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="col-6">
                <label>Estatus:</label>
                <select class="form-control form-control-sm" v-model="filtro_estado" @change="refreshTarimas">
                  <option value>TODOS</option>
                  <option value="9">ANULADO</option>
                  <option value="A">ABIERTO</option>
                  <option value="C">FINALIZADO</option>
                  <option value="D">EN CONTENEDOR</option>
                  <option value="E">EN RUTA</option>
                  <option value="H">DETALLADO</option>
                </select>
              </div>
              <div class="col-6">
                <label>Tienda Destino:</label>
                <select class="form-control form-control-sm" v-model="tienda" @change="refreshTarimas"
                  :value="current.codigo">
                  <option value="">TODAS</option>
                  <option v-for="(current, key) in tiendas" :value="current" :key="key">
                    {{ current.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-6">
                <label>Solo mostrar mis tarimas:</label>
                <br />
                <input type="checkbox" @change="refreshTarimas()" class="form-control" v-model="my_tarimas" />
              </div>
            </div>
          </div>
        </div>
        <CrearTarimaModalComponent @refreshCurrent="refreshCurrent2()" @refresh="regresar()" />
        <TarimaTicketComponent v-for="current in mis_tarimas.results" v-bind:key="current.id" :current="current"
          @onTicketClick="ticketClick" />
        <br />
        <PaginationComponent :currentPage="currentPage" :data="mis_tarimas" @pagechanged="onPageChange" />
      </div>
      <TarimaContentComponent v-if="tarimaSeleccionada != null" :current="tarimaSeleccionada" @regresar="regresar"
        @seleccionarTarima="seleccionarTarima" />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import TarimaTicketComponent from "@/components/wms/devoluciontarima/TarimaTicketComponent";
import TarimaContentComponent from "@/components/wms/devoluciontarima/TarimaContentComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CrearTarimaModalComponent from "@/components/wms/tarimas/CrearTarimaModalComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
    TarimaTicketComponent,
    TarimaContentComponent,
    CrearTarimaModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      my_tarimas: true,
      mis_tarimas: [],
      tarimaSeleccionada: null,
      id_tarima: null,
      currentPage: 1,
      searchtext: "",
      tiendas: [],
      tienda: "",
      current: "",
      filtro_estado: "A",
      filtro_abierto: true,
    };
  },
  mounted() {
    let self = this;
    this.refreshTarimas();
    this.refreshTiendas();
    setTimeout(function () {
      if (self.$route.params.id) {
        self.refreshCurrent(self.$route.params.id);
      }
    }, 5000);
  },
  methods: {
    refreshCurrent2() {
      let self = this;
      setTimeout(function () {
        DynamicService.getById("wms", "tarima", self.$route.params.id)
          .then((res) => {
            self.tarimaSeleccionada = res.data;
          })
          .catch((err) => { });
      }, 200);
    },
    refreshTiendas() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: false,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    clearFilterData() {
      let self = this;
      self.tienda = "";
      self.searchtext = null;
      self.filtro_estado = "A";
      self.filtro_abierto = true;
      this.refreshTarimas();
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      DynamicService.fetch("wms", "tarima", {
        page: this.currentPage,
        mis_tarimas: self.my_tarimas,
        estado: self.filtro_estado,
      }).then((resp) => {
        alert("");
        self.mis_tarimas = resp.data;
      });
    },
    refreshTarimas() {
      let self = this;
      if (self.filtro_abierto == true && self.searchtext) {
        self.filtro_abierto = false;
        self.filtro_estado = "";
      }
      if (self.filtro_abierto == true && self.tienda) {
        self.filtro_abierto = false;
        self.filtro_estado = "";
      }
      if (self.filtro_abierto == true && self.filtro_estado == "A") {
        self.filtro_estado = "A";
      }
      DynamicService.fetch("wms", "tarima", {
        mis_tarimas: self.my_tarimas,
        estado: self.filtro_estado,
        tipo: "DEVOLUCION",
        "filter[search]": this.searchtext,
        tienda_destino: this.tienda.codigo,
      }).then((resp) => {
        self.mis_tarimas = resp.data;
      });
    },
    ticketClick(current) {
      let self = this;
      self.id_tarima = current.id;
      self.seleccionarTarima(self.id_tarima);
    },
    seleccionarTarima(id) {
      let self = this;
      self.refreshTarimas();
      self.$router.push({
        name: "wms-devolucion-tarima-editar",
        params: { id: id },
      });
      self.refreshCurrent(id);
    },
    refreshCurrent(id) {
      let self = this;
      DynamicService.getById("wms", "tarima", id)
        .then((res) => {
          self.tarimaSeleccionada = res.data;
        })
        .catch((err) => { });
    },
    regresar() {
      this.refreshTarimas();
      this.tarimaSeleccionada = null;
      this.id_tarima = null;
      this.$router.push({
        name: "wms-devolucion-tarima",
        params: {},
      });
    },
    asignado_carrito(id) {
      this.seleccionarTarima(id);
    },
  },
};
</script>
